module.exports = __webpack_public_path__ + "static/media/RevisedIllustration.c8eec93d.webp";